//---------------------------------------------------------------------
//現在時刻を取得し、条件の合うとき時限処理
//---------------------------------------------------------------------

// 日時入力（yyyy/mm/dd HH:MM:SS）
// data-timerstart　表示開始日時　必須
// data-timerend　表示終了日時　ずっと表示の場合は"no-end"にする
// data-timerdead　dom削除日時　削除しない場合は"no-dead"にする

let currentTime = new Date();
// let currentTime = new Date('2022/09/19 00:00:01');
console.log(currentTime);

document.addEventListener("DOMContentLoaded", function () {

  //時限設定コンテンツ
  const timerTgt = Array.from(document.querySelectorAll('.js-timerTarget'));

  timerTgt.forEach(elm => {
    elm.classList.add('is-hidden');
    let startTime = elm.dataset.timerstart;
    let endTime = elm.dataset.timerend;
    let deadTime = elm.dataset.timerdead;
    let startFlag = currentTime >= Date.parse(startTime);
    let endFlag;
    let deadFlag;
    if (endTime != 'no-end') {
      endFlag = currentTime >= Date.parse(endTime);
    } else {
      endFlag = 'no-end';
    }
    if (deadTime != 'no-dead') {
      deadFlag = currentTime >= Date.parse(deadTime);
    } else {
      deadFlag = 'no-dead';
    }
    if (!startFlag) {//表示開始前
      elm.remove();
    } else if (!endFlag) {//表示後、表示終了前
      elm.dataset.status = 'start';
      elm.classList.remove('is-hidden');
    } else if (endFlag == 'no-end') {//表示後、表示終了しない
      elm.classList.remove('is-hidden');
      elm.dataset.status = 'no-end';
    } else if (!deadFlag) {//表示終了後、dom削除前
      elm.dataset.status = 'end';
      elm.classList.add('is-hidden');
    } else if (deadFlag == 'no-dead') {//表示終了後、dom削除しない
      elm.dataset.status = 'no-dead';
      elm.classList.add('is-hidden');
    } else if (deadFlag != 'no-dead') {//dom削除
      elm.remove();
    }

  });

});



